import Vue from 'vue'

// check why import axiosFactory is needed
import axiosFactory from '../../../plugins/axiosFactory'
import axios from 'axios/index'

Vue.use(axiosFactory, axios)

var resource = Vue.axiosFactory.create({baseURL: 'app/users/'})

export default {
  changePassword(data) {
    return resource({method: 'post', url: `change_password/`, data})
  },
  resetPassword(data, passwordResetToken) {
    return resource({method: 'post', url: `reset_password/`, params: {passwordResetToken}, data})
  },
  resetPasswordByUserId(userId) {
    let newPassword = '12345678'
    return resource({method: 'post', url: `${userId}/change_password`, data: {newPassword}})
  },
  updateInfoByUserId(userId, {email, name}) {
    return resource({method: 'post', url: `${userId}/update`, data: {email, name}})
  },
  get() {
    return resource({method: 'get', url: ''})
  },
  forgotPassword(email) {
    return resource({method: 'post', url: 'forgot_password', data: {email}})
  },
  getHostedPaymentFieldToken() {
    return resource({method: 'post', url: 'payments'})
  },
  listBusinessUsers() {
    return resource({method: 'get', url: 'list_business_users'})
  },
  impersonate(user) {
    return resource({method: 'post', url: 'impersonate', data: {email: user.email}})
  }
}
